import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import store from '@/store';
import globals from '@/globals';

// Layouts
import Layout from '@/layout/Layout';
import GlobalLayout from '@/layout/GlobalLayout';

Vue.use(Router)
Vue.use(Meta)

var routes = [{
  path: '/',
  component: Layout,
  children: [{
      path: '',
      component: () => import('@/pages/Index'),
      beforeEnter: guardRoute
    }, {
      path: '/index',
      component: () => import('@/pages/Index'),
      beforeEnter: guardRoute
    }, {
      path: '/home',
      component: () => import('@/pages/Home'),
      beforeEnter: guardRoute
    }, {
      path: '/dashboard/:id',
      component: () => import('@/pages/Dashboard'),
      beforeEnter: guardRoute
    }, {
      path: '/contact',
      component: () => import('@/pages/Contact'),
      beforeEnter: guardRoute
    }, {
      path: '/location',
      component: () => import('@/pages/Location'),
      beforeEnter: guardRoute
    },
    {
      path: '/tasks',
      component: () => import('@/pages/Tasks'),
      beforeEnter: guardRoute
    },
    {
      path: '/addTask',
      name: 'addTask',
      component: () => import('@/pages/AddTask'),
      props: {
        header: true,
        content: true
      },
      beforeEnter: guardRoute
    },
    {
      path: '/addNotification',
      component: () => import('@/pages/AddNotification'),
      beforeEnter: guardRoute
    },
    {
      path: '/addUser/:id',
      component: () => import('@/pages/AddUser'),
      beforeEnter: guardRoute
    },
    {
      path: '/addCompany',
      component: () => import('@/pages/AddCompany'),
      beforeEnter: guardRoute
    },
    {
      path: '/addProject',
      component: () => import('@/pages/AddProject'),
      beforeEnter: guardRoute
    },
    {
      path: '/addFtpConfig/:projectId',
      component: () => import('@/pages/AddFtpConfig'),
      beforeEnter: guardRoute
    },
    {
      path: '/users',
      component: () => import('@/pages/Users'),
      beforeEnter: guardRoute
    },
    {
      path: '/replacements',
      component: () => import('@/pages/Replacements'),
      beforeEnter: guardRoute
    },
    {
      path: '/roles',
      component: () => import('@/pages/Roles'),
      beforeEnter: guardRoute
    },
    {
      path: '/companies',
      component: () => import('@/pages/Companies'),
      beforeEnter: guardRoute
    },
    {
      path: '/projects',
      component: () => import('@/pages/Projects'),
      beforeEnter: guardRoute
    },
    {
      path: '/layouts',
      component: () => import('@/pages/Layouts'),
      beforeEnter: guardRoute
    },
    {
      path: '/profile/:id',
      component: () => import('@/pages/Profile'),
      beforeEnter: guardRoute
    },
    {
      path: '/notifications',
      component: () => import('@/pages/Notifications'),
      beforeEnter: guardRoute
    },
    {
      path: '/settings/:id',
      component: () => import('@/pages/Settings'),
      beforeEnter: guardRoute
    }
  ]
}, {
  path: '',
  component: GlobalLayout,
  children: [{
    path: '/login',
    component: () => import('@/pages/Login'),
    beforeEnter: guardRoute
  }, {
    path: '/forgot-password',
    component: () => import('@/pages/ForgotPassword')
  }, 
  {
    path: '/forbidden',
    component: () => import('@/pages/403')
  }, {
    path: '/notfound',
    component: () => import('@/pages/404')
  }, {
    path: '*',
    component: () => import('@/pages/404')
  }]
}]

const router = new Router({
  base: '/',
  mode: 'history',
  routes
})

function guardRoute(to, from, next) {
  if (store.getters.isLoggedIn) {
    if (to.path === '/login' || to.path === '/register') {
      next({
        path: '/home'
      })
    }
    next()
  }
  if (!store.getters.isLoggedIn) {
    if (to.path === '/login' || to.path === '/register') {
      next()
    } else {
      store.state.redirect = to.fullPath
      next({
        path: '/login'
      })
    }
  }
  next()
}

router.afterEach(() => {
  // On small screens collapse sidenav
  if (
    window.layoutHelpers &&
    window.layoutHelpers.isSmallScreen() &&
    !window.layoutHelpers.isCollapsed()
  ) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading')

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
